import {useLocation, useNavigate} from 'react-router-dom';
import utils from 'utils';

/**
 * LanguageSwitch - switches app language by navigating to the same path
 * with a different lang prefix. No page reload required.
 * @returns {JSX.Element}
 */
export default function LanguageSwitch() {
    const navigate = useNavigate();
    const location = useLocation();
    const lang = utils.getLanguage();

    /**
     * switchLang - navigate to the same page with a new language prefix
     * @param {string} newLang
     */
    const switchLang = (newLang: string) => {
        const parts = location.pathname.split('/').filter(Boolean);
        parts[0] = newLang;
        navigate('/' + parts.join('/') + location.search + location.hash, {replace: true});
    };

    return (
        <div className="languageSwitch">
            <span
                className={`language ${lang === 'sk' ? 'active' : ''}`}
                onClick={() => switchLang('sk')}
            >SK</span>
            <span className='divider'>|</span>
            <span
                className={`language ${lang === 'en' ? 'active' : ''}`}
                onClick={() => switchLang('en')}
            >EN</span>
        </div>
    );
}
